<template>
  <div id="app">
<!--    <div class="mask_loading">-->
<!--      <van-loading size="45" text-color="#FFFFFF" text-size="15" vertical></van-loading>-->
<!--    </div>-->
<!--    <navBar-vue class="h5_nav"></navBar-vue>-->
    <router-view></router-view>
  </div>
</template>
<script>
import {getConstant, getJsSdkConfig, getLocalWxCode, getUserId} from "@/services/user";
import {getQueryBbj, isWeiXin, isAliPay} from "@/utils/modUtils";
import router from "@/router";

const load = function load (url) {
  return new Promise(function (resolve) {
    let scriptEle = document.createElement('script')
    scriptEle.setAttribute('async', false)
    scriptEle.src = url
    scriptEle.onload = function () {
      resolve()
    }
    document.head.appendChild(scriptEle)
  })
}
export default {
  name: "App",
  computed: {

  },
  data() {
    return {
      isWx: isWeiXin(),
      isAli: isAliPay(),
    };
  },
  mounted() {
    // let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    console.log("time", new Date().getDate());
    const href = window.location.href;
    let that = this;
    // 是否是在微信,如果是,接入微信授权,如果登陆过了,也不走授权
    if (this.isWx) {
        Promise.all([load(`https://res.wx.qq.com/open/js/jweixin-1.6.0.js`), getJsSdkConfig({url: href})])
            .then(res => {
              console.log("Promise.all", res);
              let wx = window.wx
              let signInfo = res[1].data;
                const {appId, timestamp, nonceStr, signature} = signInfo
                wx.config({
                  debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                  appId: appId, // 必填，公众号的唯一标识
                  timestamp: timestamp, // 必填，生成签名的时间戳
                  nonceStr: nonceStr, // 必填，生成签名的随机串
                  signature: signature, // 必填，签名
                  jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'openLocation'] // 必填，需要使用的JS接口列表
                })
                wx.ready(function () {
                  console.log("ready");
                  that.getCode(appId);
                })
                wx.error(function (res) {
                  console.log("error", res);
                  //reject(new Error('微信授权失败:' + res.errMsg + ',appId:' + appId + ',timestamp:' + timestamp + ',nonceStr' + nonceStr + ',signature:' + signature))
                })
              })
    }else if (this.isAli){
      getConstant({}).then(res => {

        const appId = res.data.app_id;
        console.log("appid", res.data);
        const href = window.location.href
        const authCode = getQueryBbj(href).auth_code
        console.log('authCode', authCode)
        let _redirectUrl = href.indexOf('auth_code=') != -1 ? href.split('#')[0].substring(0, href.split('#')[0].indexOf('code=') - 1) + '#' + href.split('#')[1] : href.replace('/#/', '/')
        const state = href.split('?')[1]
        const url = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${appId}&scope=auth_user&redirect_uri=${encodeURIComponent(_redirectUrl)}&state=${state}`
        console.log("url", url);
        console.log("trade_no", getQueryBbj(href).trade_no);
        console.log("OrderSearch", href);
        console.log("OrderSearch", href.indexOf("orderSearch"));
        console.log("OrderSearch", !getQueryBbj(href).trade_no && href.indexOf("orderSearch") === -1);
        if (authCode) {
          if (!getQueryBbj(href).trade_no && href.indexOf("orderSearch") === -1) {
            const state = getQueryBbj(href).state
            console.log('state', state)
            window.local.href =  href + '&' + state
            return
          }
          getUserId({auth_code: authCode}).then(res => {
            window.localStorage.setItem('userInfo', JSON.stringify(res.data))
            if (res.data.code == -1) {
              window.location.href = _redirectUrl
              return
            }
          })

        } else {
          _redirectUrl = _redirectUrl.split('?')[0]
          console.log('_redirectUrl', _redirectUrl)
          console.log('url', url)
          window.location.href = url
        }
      })

    }
    else{
      console.log(router);
      router.replace({
        name: "error"
      })
    }
  },
  methods:{
    getCode(appId){
      // 获取保存在本地的code
      const localWxCode = window.localStorage.getItem('wxCode')
      const _href = window.location.href
      const _redirectUrl = _href.indexOf('code=') !== -1 ? _href.split('#')[0].substring(0, _href.split('#')[0].indexOf('code=') - 1) + '#' + _href.split('#')[1] : _href
      // 获取当前url里的code
      const wxCode = getQueryBbj(_href).code

      console.log("localWxCode", localWxCode);
      console.log("_href", _href);
      console.log("_redirectUrl", _redirectUrl);
      console.log("wxCode", wxCode);

      // eslint-disable-next-line no-debugger
      // 如果没有code表示是新进来的,直接走授权流程,同时判断当前url里的code是否和本地缓存里的一样,如果一样,则表明是刷新,走重新授权流程
      if (!localWxCode || !wxCode || localWxCode === wxCode) {
        if (!localWxCode) window.localStorage.setItem('wxCode', 'wxCode')
        console.log("appid", appId);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
            _redirectUrl
        )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        return;
      }
      // 每次把当前url里的code保存下来,以供下一次使用
      window.localStorage.setItem('wxCode', wxCode)
      getLocalWxCode({
        localWxCode,
        code: wxCode,
        state: getQueryBbj(window.location.href).state
      }).then(resOpenId => {
        console.log("resOpenId", resOpenId.data);
        if (resOpenId.data.code === -1) {
          window.location.href = _redirectUrl
          return
        }
        const userInfo = { ...resOpenId.data }
        console.log("userInfo", userInfo);
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
      }).catch(err => {
        console.log(err);
      })
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #f5f5f5;
  margin: 0;
  padding: 0;
  z-index: 9;
}
.mask_loading {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.h5_nav {
  position: fixed !important;
  top: 0;
  width: 100%;
}
</style>
